/* ============================================================================
   OLBIY HELLOSLIM BOXER — Shopify section script
   Landing script.js + enhance.js'in Shopify'a uyarlanmış hali.
   ÇIKARILDI: kendi navbar/mobil menü/footer/legal modal/stoktv iframe formu.
   EKLENDİ  : Shopify sepet + paket modalı.
   Veriler: window.HSK (section schema'dan gelir)
   ============================================================================ */
(function () {
  'use strict';

  var CFG = window.HSK || {};
  var root = document.querySelector('.hsk');
  if (!root) return;

  /* ---------------- scroll reveal ---------------- */
  function reveal() {
    var items = root.querySelectorAll('.reveal');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px' });
    items.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- SSS ---------------- */
  function faq() {
    root.querySelectorAll('.faq-list details').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        root.querySelectorAll('.faq-list details').forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  /* ---------------- yumuşak kaydırma (tema başlığı için pay) ---------------- */
  function smooth() {
    root.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href');
        if (!href || href === '#') return;
        var t = root.querySelector(href);
        if (!t) return;
        e.preventDefault();
        var top = t.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  /* ---------------- sabit alt bar + WhatsApp ---------------- */
  function floats() {
    var bar = root.querySelector('.floating-order');
    var wa = root.querySelector('.wa-float');
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (bar) bar.classList.toggle('show', y > 620);
      if (wa) wa.classList.toggle('show', y > 600);
    }, { passive: true });
  }

  /* ---------------- paket seçimi ---------------- */
  var selected = null;

  var selPaket = null, selBeden = null;

  function fmtVariants() { return (CFG.variants || []); }

  function resolve() {
    var vs = fmtVariants();
    var match = null;
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].paket === selPaket && (selBeden === null || vs[i].beden === selBeden)) {
        if (selBeden !== null) { match = vs[i]; break; }
      }
    }
    var hid = root.querySelector('#hskVariantId');
    if (hid && match) hid.value = match.id;
    root.querySelectorAll('.hsk-buy').forEach(function (go) {
      if (match && match.available) {
        go.disabled = false; go.innerHTML = 'Kapıda Ödemeli Siparişi Tamamla <span>→</span>';
      } else {
        go.disabled = true; go.innerHTML = selPaket && selBeden ? 'Bu beden tükendi' : 'Önce beden seçin';
      }
    });
    root.querySelectorAll('[data-bd-hint]').forEach(function (e) {
      e.textContent = selBeden ? '· ' + selBeden + ' seçildi' : '· lütfen seçin';
    });
  }

  function pickPaket(card) {
    if (!card) return;
    selPaket = card.getAttribute('data-paket');
    root.querySelectorAll('.pkg-card, .tk-chip').forEach(function (c) {
      c.classList.toggle('sel', c.getAttribute('data-paket') === selPaket);
    });
    card.classList.remove('pop'); void card.offsetWidth; card.classList.add('pop');
    setTimeout(function () { card.classList.remove('pop'); }, 500);
    root.querySelectorAll('.pkg-save').forEach(function (sv) {
      sv.classList.remove('save-flash'); void sv.offsetWidth; sv.classList.add('save-flash');
      setTimeout(function () { sv.classList.remove('save-flash'); }, 900);
    });
    var price = card.getAttribute('data-price');
    var unit = card.getAttribute('data-unit');
    var qty = card.getAttribute('data-qty');
    var save = card.getAttribute('data-save');
    root.querySelectorAll('[data-pkg-total],[data-price-now],[data-hero-price]').forEach(function (e) {
      if (e.textContent !== price) {
        e.textContent = price;
        e.classList.add('price-flash');
        setTimeout(function () { e.classList.remove('price-flash'); }, 450);
      }
    });
    root.querySelectorAll('[data-hero-note]').forEach(function (e) { e.textContent = qty + ' adet · adet başı ' + unit; });
    root.querySelectorAll('[data-adet-badge]').forEach(function (e) { e.textContent = qty + ' ADET'; });
    root.querySelectorAll('.ho-ship').forEach(function (e) { e.textContent = '🚚 Kargo bedava'; });
    root.querySelectorAll('[data-bar-price]').forEach(function (e) { e.textContent = qty + ' Adet · ' + price; });
    root.querySelectorAll('[data-bar-note]').forEach(function (e) {
      e.textContent = 'Kapıda ödeme · Kargo bedava' + (save ? ' · ' + save + ' cepte' : '');
    });
    root.querySelectorAll('[data-price-note]').forEach(function (e) {
      e.innerHTML = 'Bu fiyat <b>' + qty + ' adet boxerın toplamıdır</b> · adet başı <b>' + unit + '</b> · <b>Kargo bedava</b>' + (save ? ' · <b>' + save + ' cebinde kaldı</b>' : '');
    });
    root.querySelectorAll('[data-bar2-adet]').forEach(function (e) { e.textContent = qty + ' Adet'; });
    root.querySelectorAll('[data-bar2-price]').forEach(function (e) { e.textContent = price; });
    resolve();
  }

  function pickBeden(btn) {
    selBeden = btn.getAttribute('data-beden');
    root.querySelectorAll('.beden-btn').forEach(function (b) {
      b.classList.toggle('sel', b.getAttribute('data-beden') === selBeden);
    });
    resolve();
  }

  function packages() {
    var cards = root.querySelectorAll('.pkg-card, .tk-chip');
    if (!cards.length) return;
    cards.forEach(function (c) { c.addEventListener('click', function () { pickPaket(c); }); });
    root.querySelectorAll('.beden-btn').forEach(function (b) {
      b.addEventListener('click', function () { pickBeden(b); });
    });
    pickPaket(root.querySelector('.pkg-card.sel') || cards[0]);
  }

  /* ---------------- sipariş modalı (popup) ---------------- */
  function modal() {
    var m = root.querySelector('#hskModal');
    if (!m) return;
    function open(e) {
      if (e) e.preventDefault();
      m.classList.add('open'); m.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () {
        var f = m.querySelector('#hsAd');
        if (f && !f.value) { try { f.focus({ preventScroll: true }); } catch (err) {} }
      }, 260);
    }
    function close() {
      m.classList.remove('open'); m.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    root.querySelectorAll('.js-order').forEach(function (b) { b.addEventListener('click', open); });
    m.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', close); });
    m.addEventListener('click', function (e) { if (e.target === m) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ============================================================================
     ÖDEME SAYFASINA GEÇ  (ön-dolum YOK)
     Müşteri sadece paket + beden seçer; adres/kişisel bilgileri Shopify'ın
     KENDİ ödeme sayfasında girer ve orada "Siparişi Tamamla"ya basar.
     Shopify checkout altyapısı + Meta pikseli birebir korunur.
       1) sepeti temizle (çift tıkta birikmesin)
       2) NATIVE form POST -> /cart/add + return_to=/checkout
          (submit() olay dinleyicilerini atlar; tema sepet-drawer'ı araya girmez)
     ============================================================================ */
  function checkoutWith(vid, btn) {
    if (!vid) return;
    var addUrl = (CFG.cartAddUrl || '/cart/add');
    var clearUrl = (CFG.cartClearUrl || '/cart/clear') + '.js';
    var old = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Ödeme sayfasına geçiliyor...'; }

    function go() {
      var f = document.createElement('form');
      f.method = 'post'; f.action = addUrl; f.style.display = 'none';
      [['id', String(vid)], ['quantity', '1'], ['return_to', '/checkout']].forEach(function (kv) {
        var i = document.createElement('input');
        i.type = 'hidden'; i.name = kv[0]; i.value = kv[1];
        f.appendChild(i);
      });
      document.body.appendChild(f);
      HTMLFormElement.prototype.submit.call(f);
    }

    var done = false;
    function once() { if (!done) { done = true; go(); } }
    setTimeout(once, 1200);                       // temizleme takılırsa yine de git
    fetch(clearUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(once).catch(once);
    if (btn) setTimeout(function () { btn.disabled = false; btn.innerHTML = old; }, 8000);
  }

  function buy() {
    root.querySelectorAll('.hsk-buy').forEach(function (b) {
      b.addEventListener('click', function () {
        var h = root.querySelector('#hskVariantId'); var vid = h && h.value;
        checkoutWith(vid, b);
      });
    });
  }

  /* ---------------- geri sayım ---------------- */
  function countdown() {
    var units = root.querySelector('[data-timer-units]');
    var txt = root.querySelector('[data-timer-text]');
    var sub = root.querySelector('[data-timer-subtext]');
    if (!units || !CFG.countdown) return;
    var KEY = 'olbiy_hsk_deadline', W = 864e5, deadline;
    try {
      var st = parseInt(localStorage.getItem(KEY), 10);
      if (!st || st < Date.now()) { st = Date.now() + W; localStorage.setItem(KEY, String(st)); }
      deadline = st;
    } catch (e) { deadline = Date.now() + W; }
    units.hidden = false;
    if (txt) txt.textContent = 'Kampanya bitişine';
    if (sub) sub.textContent = 'Bu avantaj sayaç bitene kadar geçerli';
    var d = units.querySelector('[data-days]'), h = units.querySelector('[data-hours]'),
        m = units.querySelector('[data-minutes]'), s = units.querySelector('[data-seconds]');
    function p(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var df = Math.max(0, deadline - Date.now());
      if (d) d.textContent = p(Math.floor(df / 864e5));
      if (h) h.textContent = p(Math.floor(df % 864e5 / 36e5));
      if (m) m.textContent = p(Math.floor(df % 36e5 / 6e4));
      if (s) s.textContent = p(Math.floor(df % 6e4 / 1e3));
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------------- stok çubuğu ---------------- */
  function stock() {
    var cap = Number(CFG.stockTotal), left = Number(CFG.stockLeft);
    var meter = root.querySelector('[data-stock-meter]');
    var txt = root.querySelector('[data-stock-text]');
    var sub = root.querySelector('[data-stock-subtext]');
    if (!meter || !cap || !left || left > cap) return;
    var pct = Math.max(4, Math.round(left / cap * 100));
    requestAnimationFrame(function () { meter.style.width = pct + '%'; });
    if (txt) txt.textContent = left + ' / ' + cap + ' adet kaldı';
    if (sub) sub.textContent = 'Kampanya stoğu sınırlıdır';
  }


  /* hero slayt shovu (6 renk, 2sn) */
  function heroSlider() {
    var wrap = document.getElementById('heroSlider');
    if (!wrap) return;
    var slides = wrap.querySelectorAll('.hs-slide');
    var navs = document.querySelectorAll('.hs-nav');
    if (slides.length < 2) return;
    var i = 0, timer = null;
    function show(n) {
      i = (n + slides.length) % slides.length;
      for (var k = 0; k < slides.length; k++) slides[k].classList.toggle('sel', k === i);
      for (var m = 0; m < navs.length; m++) navs[m].classList.toggle('sel', m === i);
    }
    function play() { timer = setInterval(function () { show(i + 1); }, 2000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    for (var n = 0; n < navs.length; n++) (function (x) {
      navs[x].addEventListener('click', function () { stop(); show(x); play(); });
    })(n);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce) play();
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : (reduce || play()); });
  }

  /* ---------------- hero thumb galerisi (tasarim katmani 2026) ---------------- */
  function heroThumbs() {
    var main = root.querySelector('#heroMain');
    var thumbs = root.querySelectorAll('.hero-thumbs .ht');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        if (src && main.getAttribute('src') !== src) {
          main.style.opacity = 0;
          setTimeout(function () {
            main.setAttribute('src', src);
            main.style.opacity = 1;
          }, 160);
        }
        thumbs.forEach(function (x) { x.classList.toggle('sel', x === t); });
      });
    });
    main.style.transition = 'opacity .18s ease, transform .6s ease';
  }

  /* ---------------- beden yardimcisi ---------------- */
  function bedHelper() {
    var wrap = root.querySelector('[data-bed-helper]');
    if (!wrap) return;
    var res = wrap.querySelector('[data-bed-result]');
    var name = wrap.querySelector('[data-bed-name]');
    var rows = root.querySelectorAll('.bed-wrap tbody tr');
    wrap.querySelectorAll('.bh-chips button').forEach(function (b) {
      b.addEventListener('click', function () {
        wrap.querySelectorAll('.bh-chips button').forEach(function (x) { x.classList.toggle('sel', x === b); });
        var bed = b.getAttribute('data-bed');
        if (name) name.textContent = bed;
        if (res) res.hidden = false;
        rows.forEach(function (tr) {
          tr.classList.toggle('bed-hi', (tr.textContent || '').trim().indexOf(bed) === 0);
        });
      });
    });
  }

  /* ---------------- WhatsApp karsilama balonu (oturumda 1 kez) ---------------- */
  function waTip() {
    var wa = document.querySelector('.wa-float');
    if (!wa) return;
    var shown = false;
    try { shown = sessionStorage.getItem('hsk_watip') === '1'; } catch (e) {}
    if (shown) return;
    var tip = document.createElement('div');
    tip.className = 'wa-tip';
    tip.innerHTML = 'Sorun mu var? Yaz\u0131n \uD83D\uDC4B<button type="button" aria-label="Kapat">\u00D7</button>';
    document.body.appendChild(tip);
    setTimeout(function () { tip.classList.add('show'); }, 6000);
    function hide() { tip.classList.remove('show'); try { sessionStorage.setItem('hsk_watip', '1'); } catch (e) {} }
    tip.querySelector('button').addEventListener('click', hide);
    setTimeout(hide, 16000);
  }

  /* ---------------- 16:00 kargo kesim saati (dürüst aciliyet) ---------------- */
  function shipCutoff() {
    var els = root.querySelectorAll('[data-ship-cutoff]');
    if (!els.length) return;
    function apply() {
      var h = new Date().getHours();
      var t = (h < 16)
        ? '📦 Bugün 16:00\'a kadar sipariş = bugün kargoda'
        : '📦 Şimdi sipariş ver — yarın ilk kargoyla yola çıksın';
      els.forEach(function (e) { e.textContent = t; });
    }
    apply(); setInterval(apply, 60000);
  }

  /* ---------------- haftanın renk takvimi ---------------- */
  function renkTakvim() {
    var strip = root.querySelector('[data-tv-strip]');
    if (!strip) return;
    var img = root.querySelector('[data-tv-img]');
    var cap = root.querySelector('[data-tv-cap]');
    var btns = strip.querySelectorAll('button');
    function pick(b) {
      btns.forEach(function (x) { x.classList.toggle('sel', x === b); });
      if (img && b.dataset.img && img.getAttribute('src') !== b.dataset.img) {
        img.style.opacity = 0;
        setTimeout(function () { img.setAttribute('src', b.dataset.img); img.style.opacity = 1; }, 180);
      }
      if (cap) cap.textContent = b.dataset.cap || '';
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { pick(b); }); });
    var day = (new Date().getDay() + 6) % 7;
    if (btns[day]) pick(btns[day]);
    if (img) img.style.transition = 'opacity .2s ease';
  }

  /* ---------------- sıradan vs Hello Slim sürgüsü ---------------- */
  function cmpSlider() {
    var frame = root.querySelector('[data-cs-frame]');
    if (!frame) return;
    var top = frame.querySelector('[data-cs-top]');
    var handle = frame.querySelector('[data-cs-handle]');
    var inner = top ? top.querySelector('img') : null;
    if (!top || !handle) return;
    function fit() { if (inner) inner.style.width = frame.getBoundingClientRect().width + 'px'; }
    function setPct(pct) {
      pct = Math.min(96, Math.max(4, pct));
      top.style.width = pct + '%';
      handle.style.left = pct + '%';
    }
    function fromEvent(e) {
      var r = frame.getBoundingClientRect();
      var x = (e.touches && e.touches[0] ? e.touches[0].clientX : e.clientX) - r.left;
      setPct(x / r.width * 100);
    }
    var drag = false;
    ['pointerdown', 'touchstart'].forEach(function (ev) {
      frame.addEventListener(ev, function (e) { drag = true; fromEvent(e); }, { passive: true });
    });
    ['pointermove', 'touchmove'].forEach(function (ev) {
      window.addEventListener(ev, function (e) { if (drag) fromEvent(e); }, { passive: true });
    });
    ['pointerup', 'touchend', 'pointercancel'].forEach(function (ev) {
      window.addEventListener(ev, function () { drag = false; }, { passive: true });
    });
    window.addEventListener('resize', fit, { passive: true });
    fit(); setPct(50);
  }

  /* ---------------- masaüstü sticky üst teklif barı ---------------- */
  function topBar() {
    var bar = root.querySelector('[data-top-bar]');
    if (!bar) return;
    window.addEventListener('scroll', function () {
      bar.classList.toggle('show', window.scrollY > 800 && window.innerWidth > 900);
    }, { passive: true });
  }

  /* ---------------- hero hafif parallax ---------------- */
  function heroParallax() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var img = root.querySelector('.hero-visual img');
    var b1 = root.querySelector('.hs-float-1'), b2 = root.querySelector('.hs-float-2');
    if (!img) return;
    var raf = 0;
    window.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        var y = Math.min(window.scrollY, 700);
        img.style.transform = 'translateY(' + (y * -0.04) + 'px) scale(1.02)';
        if (b1) b1.style.translate = '0 ' + (y * 0.05) + 'px';
        if (b2) b2.style.translate = '0 ' + (y * 0.03) + 'px';
        raf = 0;
      });
    }, { passive: true });
  }

  function init() { reveal(); faq(); smooth(); floats(); packages(); modal(); buy(); countdown(); stock();  heroSlider(); heroThumbs(); bedHelper(); waTip(); heroParallax(); shipCutoff(); renkTakvim(); cmpSlider(); topBar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
